import React from "react";
import Tooltip from "rc-tooltip";
import IconButton from "../../../../common/icon-button/icon-button";

const WidgetHeaderButton = ({
  showButton,
  iconName,
  onClick,
  hoverTooltip,
  customClassName
}) => {
  const className = customClassName ? `glu-flex-shrink ${customClassName}` : 'glu-flex-shrink';
  return showButton ? (
    <div className={className}>
      <Tooltip
        placement="top"
        trigger={["hover"]}
        overlay={<span>{hoverTooltip}</span>}
      >
        <button className="glu-btn-link glu-tooltip">
          <IconButton icon={iconName} onClick={onClick} />
        </button>
      </Tooltip>
    </div>
  ) : null;
};

export default WidgetHeaderButton;
